import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { CRMService } from '../../services/crm.service';
import { UtilService } from '../../services/util.service';
import {
    SearchCustomerTeam
} from '../../models/models';

@Component({
    selector: 'customer-team-list',
    templateUrl: './customer-team-list.component.html',
    standalone: false
})
export class CustomerTeamList implements OnChanges, OnInit {
    @Input() customerID: number = 0;

    public searchCustomerTeamList: SearchCustomerTeam[] = [];

    constructor(private crmService: CRMService, private utilService: UtilService) {
    }

    ngOnInit() {
    }

    ngOnChanges() {
        this.getSearchCustomerTeam();
    }

    private getSearchCustomerTeam() {
        this.utilService.isLoading = true;
        this.crmService.getSearchCustomerTeamByCustomerID(this.customerID).subscribe(result => {
            this.utilService.isLoading = false;
            this.searchCustomerTeamList = result.resultCollection;
            this.searchCustomerTeamList = this.searchCustomerTeamList.filter(t => t.isEmployeeActive == true);
        });
    }
}
